module.exports = __webpack_public_path__ + "static/media/jassyro.0279ddae.png";